export enum SoleTraderFormStep {
  CONSENT = "ABN_SOLE_TRADER_CONSENT",
  FLOW_SELECT = "ABN_SOLE_TRADER_FLOW_SELECT",
  SOLE_TRADER_DECISION = "ABN_SOLE_TRADER_SOLE_TRADER_DECISION",
  DIRECTOR = "ABN_SOLE_TRADER_DIRECTOR",
  ABN = "ABN_SOLE_TRADER_ABN",
  IDENTITY = "ABN_SOLE_TRADER_IDENTITY",
  BASKET = "ABN_SOLE_TRADER_BASKET",
  CONFIRM = "ABN_SOLE_TRADER_CONFIRM",
  CHARGE = "ABN_SOLE_TRADER_CHARGE",
  COMPLETE = "ABN_SOLE_TRADER_COMPLETE",
}

export const FORM_STEP_TO_PATH: Record<SoleTraderFormStep, string> = {
  [SoleTraderFormStep.CONSENT]: "consent",
  [SoleTraderFormStep.FLOW_SELECT]: "flow-select",
  [SoleTraderFormStep.SOLE_TRADER_DECISION]: "sole-trader-decision",
  [SoleTraderFormStep.DIRECTOR]: "director",
  [SoleTraderFormStep.ABN]: "abn-details",
  [SoleTraderFormStep.IDENTITY]: "identity",
  [SoleTraderFormStep.BASKET]: "basket",
  [SoleTraderFormStep.CHARGE]: "charge",
  [SoleTraderFormStep.CONFIRM]: "confirm",
  [SoleTraderFormStep.COMPLETE]: "complete",
};
